export const NAME = 'pagination';
